import { Flex } from "@ecco/ui/flex";
import { FormControl } from "@ecco/ui/form-control";
import { Radio, RadioGroup } from "@ecco/ui/radio";
import { styles } from "./baseFormStyles";
import type { RadioGroupProps } from "./baseFormsValidations";
import { FormLabel } from "@ecco/ui/form-label";
import { FormErrorMessage } from "@ecco/ui/form-error";

interface genderProps extends RadioGroupProps {
    setUpdateGender: any;
}

export const GenderField = ({
    values,
    defaultValue,
    isDisabled = false,
    header,
    setUpdateGender,
    isInvalid = false,
    error,
}: genderProps) => {
    return (
        <>
            <FormControl isDisabled={isDisabled} isInvalid={isInvalid}>
                <FormLabel mt={4} sx={styles.formLabel}>
                    {header}
                </FormLabel>
                <RadioGroup
                    id="gender"
                    name="gender"
                    onChange={(val) => {
                        setUpdateGender(val);
                    }}
                    defaultValue={defaultValue}
                    h={["inherit", 5]}
                >
                    <Flex gap={3} direction={["column", "row"]}>
                        {values.map((item) => (
                            <Radio key={item.value} value={item.value} sx={styles.genderField}>
                                {item.label}
                            </Radio>
                        ))}
                    </Flex>
                </RadioGroup>

                <FormErrorMessage>{error}</FormErrorMessage>
            </FormControl>
        </>
    );
};

export default GenderField;
